import { LoaderCircle } from 'lucide-react';
import { useBrand } from '@/features/branding/brand-provider';
import { LocationsList } from '@/features/locations/locations-list';
import { NotFound } from '@/routes/not-found';

// Ports app/[brand]/admin/locations/page.tsx: the list is meaningful only for a
// portfolio site; anything else is a 404. Renders content inside the admin
// Shell.
export function Locations() {
  const { brand: site, loading } = useBrand();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <LoaderCircle className="text-primary size-8 animate-spin" />
      </div>
    );
  }

  if (site.siteType !== 'portfolio') {
    return <NotFound />;
  }

  return <LocationsList />;
}
